import axios from "axios";
export const state = {
    discharge_status: [],
    save_status: false,
    dischargepatientId: "",
    dischargeform: {},
    discharge_patients: [],
    referpatientId: "",
    referred_patients: [],
    referralform: {},
    referhealthunits: []
};
export const getters = {
    DischargeStatuses: state => state.discharge_status,
    SaveStatus: state => state.save_status,
    DischargePrintId: state => state.dischargepatientId,
    Dischargeform: state => state.dischargeform.data,
    DischargePatients: state => state.discharge_patients.data,
    ReferPrintId: state => state.referpatientId,
    ReferredPatients: state => state.referred_patients.data,
    Referralform: state => state.referralform.data,
    ReferHealthUnitsData: state => state.referhealthunits,
};

export const mutations = {
    SET_DISCHARGE_STATUS(state, newValue) {
        state.discharge_status = newValue;
    },
    SET_DISCHARGED_PATIENTS(state, newValue) {
        state.discharge_patients = newValue;
    },
    SET_REFERRED_PATIENTS(state, newValue) {
        state.referred_patients = newValue;
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue;
        if (newValue == true) {
            state.dischargepatientId = "";
        }
    },
    SET_HEALTH_UNITS(state, newValue) {
        state.referhealthunits = newValue;
    },
    SET_DISCHARGE_ID(state, newValue) {
        state.dischargepatientId = newValue;
    },
    SET_REFER_ID(state, newValue) {
        state.referpatientId = newValue;
    },
    SET_DISCHARGE_FORM(state, newValue) {
        state.dischargeform = newValue;
    },
    SET_REFERRAL_FORM(state, newValue) {
        state.referralform = newValue;
    },
    SET_DISCHARGE_FORM_TEMPALTE(state) {
        state.dischargeform = {
            "data": {
                "id": "",
                "branch_id": "",
                "clinic": "",
                "patient": "",
                "patient_gender": "",
                "age": "",
                "age_unit": "",
                "admission_date": "",
                "discharge_date": "",
                "status": "",
                "wards": "",
                "officer": "",
                "followupdate": "",
                "provisional_diagnosis": "",
                "final_diagnosis": "",
                "followupplace": "",
                "clinical_presentation": "",
                "intervation": "",
                "reccomendation": "",
                "diagnosis_id": "",
                "updated_at": "",
                "created_at": ""
            }
        };
    },
    SET_REFERRAL_FORM_TEMPALTE(state) {
        state.referralform = {};
    },
};

export const actions = {
    fetchHealthUnits({ commit, dispatch }) {
        axios.get('referhealthunits').then(res => {
            commit('SET_HEALTH_UNITS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    saveDischargeInformation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true)
        axios.post('inpatient_management', payload).then(res => {
            commit('SET_SAVE_STATUS', false)
            dispatch('visits/fetchVisitProfileAlone', payload.visit_id, { root: true })
            commit('SET_DISCHARGE_ID', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    fetchDischargeStatus({ commit, dispatch }) {
        axios.get('discharge_statuses').then(res => {
            commit('SET_DISCHARGE_STATUS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    print_dischargeForm({ commit, dispatch }, payload) {
        commit("SET_DISCHARGE_FORM_TEMPALTE")
        axios.get(`inpatient_management/${payload}`).then(res => {
            commit('SET_DISCHARGE_FORM', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    fetchDischargedPatients({ commit, dispatch }) {
        axios.get('inpatient_management').then(res => {
            commit('SET_DISCHARGED_PATIENTS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    saveReferralInformation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true)
        axios.post('savereferral', payload).then(res => {
            commit('SET_SAVE_STATUS', false)
            dispatch('visits/fetchVisitProfileAlone', payload.visit_id, { root: true })
            commit('SET_REFER_ID', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchReferedPatients({ commit, dispatch }) {
        axios.get('referedPatients').then(res => {
            commit('SET_REFERRED_PATIENTS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    print_referForm({ commit, dispatch }, payload) {
        commit("SET_REFERRAL_FORM_TEMPALTE")
        axios.get(`referedPatientForm/${payload}`).then(res => {
            commit('SET_REFERRAL_FORM', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
};